module.exports = __webpack_public_path__ + "img/Logotipo Yego.45714c6c.svg";